module.exports = __webpack_public_path__ + "img/browser.163103a2.svg";